export default "__VITE_ASSET__CRWHeZXf__"